import { render, staticRenderFns } from "./componentsPage.vue?vue&type=template&id=2c42420d&scoped=true"
import script from "./componentsPage.vue?vue&type=script&lang=js"
export * from "./componentsPage.vue?vue&type=script&lang=js"
import style0 from "./componentsPage.vue?vue&type=style&index=0&id=2c42420d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42420d",
  null
  
)

export default component.exports